import Base from '../Pages/Base'
import List from '../Pages/List'
import Form from '../Pages/Form'

const firstCargo = 'orientacoes-informacoes'

export default [
	{
		path: 'servicos/classificacao-semed',
		component: Base,
		redirect: `/servicos/classificacao-semed/${firstCargo}`,
		children: [
			{
				path: ':cargo',
				name: 'ListClassificacaoSemed',
				component: List,
				meta: {
					path: '/servicos/classificacao-semed',
					pai: 'Serviços',
					title: 'Admin - Classificação SEMED',
					navigation: [
						{
							pagina: 'Home',
							class: 'ace-icon fa fa-home home-icon',
							active: false,
							url: '/',
						},
						{
							pagina: 'Classificação SEMED',
							class: '',
							active: true,
							url: false,
						},
					],
					noCache: true,
				},
			},
			{
				path: ':cargo/novo',
				name: 'FormClassificacaoSemed',
				component: Form,
				meta: {
					path: '/servicos/classificacao-semed',
					pai: 'Serviços',
					title: 'Admin - Classificação SEMED - Novo',
					navigation: [
						{
							pagina: 'Home',
							class: 'ace-icon fa fa-home home-icon',
							active: false,
							url: '/',
						},
						{
							pagina: 'Classificação SEMED',
							class: '',
							active: false,
							url: '/servicos/classificacao-semed',
						},
						{
							pagina: 'Novo',
							class: '',
							active: true,
							url: false,
						},
					],
					noCache: true,
				},
			},
			{
				path: ':cargo/editar/:id',
				name: 'FormClassificacaoSemedEditar',
				component: Form,
				meta: {
					path: '/servicos/classificacao-semed',
					pai: 'Serviços',
					title: 'Admin - Classificação SEMED - Editar',
					navigation: [
						{
							pagina: 'Home',
							class: 'ace-icon fa fa-home home-icon',
							active: false,
							url: '/',
						},
						{
							pagina: 'Classificação SEMED',
							class: '',
							active: false,
							url: '/servicos/classificacao-semed',
						},
						{
							pagina: 'Editar',
							class: '',
							active: true,
							url: false,
						},
					],
					noCache: true,
				},
			},
		],
	},
]
